// extracted by mini-css-extract-plugin
export default {"red":"red__ueWrL"};